import React from "react";
import { Route, Switch } from "react-router-dom";

import { ThemeProvider } from "@mui/material/styles";
import X360Theme from "../../../themes/X360Theme";

import Dashboard from "./Dashboard";

const X360Router = () => (
    <ThemeProvider theme={X360Theme}>
        <Switch>
            <Route path="/x360/" component={Dashboard} />
        </Switch>
    </ThemeProvider>
);

export default X360Router;
